

























import {Component, Prop} from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import DocumentSharing from '@/components/DocumentSharing.vue';

@Component({
  components: {DocumentSharing},
})
export default class MetaValuation extends CompanyMixin {
  @Prop() readonly doc!: any;

  get showIntro() {
    const item = this.doc.Data.Items.find((x: any) => x.Type === 'custom_intro');
    return item && item.Hidden !== true;
  }

  get showOutro() {
    const item = this.doc.Data.Items.find((x: any) => x.Type === 'custom_outro');
    return item && item.Hidden !== true;
  }

  get method() {
    const s = this.doc.Data.Items.find((x: any) => x.Type === 'cashflow_method');
    switch (s.Method) {
      case 'complete':
        return 'Visar komplett metodik (7 slides)';
    }
    return 'Visar kompakt metodik (3 slides)';
  }

  get table() {
    const s = this.doc.Data.Items.find((x: any) => x.Type === 'cashflow_analysis');
    switch (s.Table) {
      case 'detailed':
        return 'Inkluderar detaljerad kassaflödestabell';
    }
    return 'Ingen kassaflödestabell inkluderas';
  }

  get rec() {
    const s = this.doc.Data.Items.find((x: any) => x.Type === 'cashflow_analysis');
    switch (s.Recommendation) {
      case 'financing':
      case 'cashflowRecommendation_financing':
        return 'Fokus på bolagets finansiering';
      case 'investments':
      case 'cashflowRecommendation_investments':
        return 'Fokus på bolagets investeringar';
      case 'workingcapital':
      case 'cashflowRecommendation_workingcapital':
        return 'Fokus på bolagets rörelsekapital';
      case 'daytoday':
      case 'cashflowRecommendation_daytoday':
        return 'Fokus på operativ verksamhet';
    }
    return 'Ingen rekommendation lämnas';
  }
}
